import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { NonPersistedSlice } from "../types"

const initialState: NonPersistedSlice = {
  showSubscriptionsModalOnAppLoad: false,
  pendingSubscriptionUrl: null,
  allConversationsTableState: {
    page: 0,
    rowsPerPage: 10,
    searchTerm: "",
  },
}

const nonPersistedSlice = createSlice({
  name: "nonPersisted",
  initialState,
  reducers: {
    updateShowSubscriptionsModalOnAppLoad: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.showSubscriptionsModalOnAppLoad = action.payload
    },
    resetShowSubscriptionsModalOnAppLoad: (state) => {
      state.showSubscriptionsModalOnAppLoad = false
    },
    updatePendingSubscriptionUrl: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.pendingSubscriptionUrl = action.payload
    },
    updateAllConversationsTableState: (
      state,
      action: PayloadAction<NonPersistedSlice["allConversationsTableState"]>,
    ) => {
      state.allConversationsTableState = action.payload
    },
    resetState: () => initialState,
  },
})

export const NonPersistedActions = nonPersistedSlice.actions
export default nonPersistedSlice.reducer
